<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card flat>
          <div itemprop="image">
          <v-card-media
            class="edomargintop"
            height="450px"
            alt="Produktbild edologic Produkte"
            :src="require('../assets/edologic_produkte1.jpg')">
            <v-container fill-height>
              <v-layout fill-height>
                <v-flex xs12 align-end flexbox>
                  <span itemprop="description">
                  <span class="edoheadline textshadow">PRODUKTE <br> DIE BEGEISTERN</span>
                  </span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-media>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
    <v-container fluid grid-list-md>
      <v-layout row wrap justify-space-around>
        <v-flex d-flex xs12 sm12 md4 link>
          <div itemprop="itemListElement" itemscope itemtype="http://schema.org/Product" class="linkedo">
            <a itemprop="url" href="https://edologic.de/produkte/crossfind">
          <router-link :to="'/produkte/crossfind'" class="link">
          <v-card class="edomargintop"  flat>
            <v-card-title primary class="title edoheadlinetext">
              <span itemprop="name">
              CROSSFIND
              </span>
            </v-card-title>
            <v-card-text>
              <span itemprop="description">
              Die findige Lösung für Ihre Dokumente –
              kein lästiges suchen mehr von Schriftstücken.
              </span>
            </v-card-text>
            <v-card-text>
              <div>
                <i class="fa fa-angle-right fa-2x edocolor" aria-hidden="true"></i>
                <router-link :to="'/produkte/crossfind'" class="edolinkgross">
                  <a itemprop="url" href="https://edologic.de/produkte/crossfind">
                  <span>MEHR ERFAHREN</span>
                  </a>
                </router-link>
              </div>
            </v-card-text>
          </v-card>
          </router-link>
            </a>
          </div>
        </v-flex>
        <v-flex d-flex xs12 sm12 md4>
          <div itemprop="itemListElement" itemscope itemtype="http://schema.org/Product" class="linkedo">
            <a itemprop="url" href="https://edologic.de/produkte/examenis">
          <router-link :to="'/produkte/examenis'" class="link">
          <v-card class="edomargintop"  flat>
            <v-card-title primary class="title edoheadlinetext">
              <span itemprop="name">
              EXAMENIS
              </span>
            </v-card-title>
            <v-card-text>
              <span itemprop="description">
              Das Programm um Prüfungen und Umfragen zu automatisieren –
              mit wenigen Klicks zum Erfolg.
              </span>
            </v-card-text>
            <v-card-text>
              <div>
                  <i class="fa fa-angle-right fa-2x edocolor" aria-hidden="true"></i>
                  <router-link :to="'/produkte/examenis'" class="edolinkgross">
                    <a itemprop="url" href="https://edologic.de/produkte/examenis">
                    <span>MEHR ERFAHREN</span>
                    </a>
                  </router-link>
              </div>
            </v-card-text>
          </v-card>
          </router-link>
            </a>
          </div>
        </v-flex>
        <v-flex d-flex xs12 sm12 md4>
          <div itemprop="itemListElement" itemscope itemtype="http://schema.org/Product" class="linkedo">
            <a itemprop="url" href="https://edologic.de/produkte/surfandscan">
          <router-link :to="'/produkte/surfandscan'" class="link">
          <v-card class="edomargintop" flat>
            <v-card-title primary class="title edoheadlinetext">
              <span itemprop="name">
              SURF AND SCAN
              </span>
            </v-card-title>
            <v-card-text>
              <span itemprop="description">
              Surf and Scan – <br>
              verbindet das Einfache mit dem Nützlichen
              </span>
            </v-card-text>
            <v-card-text>
              <div>
                <i class="fa fa-angle-right fa-2x edocolor" aria-hidden="true"></i>
                <router-link :to="'/produkte/surfandscan'" class="edolinkgross">
                  <a itemprop="url" href="https://edologic.de/produkte/surfandscan">
                  <span>MEHR ERFAHREN</span>
                  </a>
                </router-link>
              </div>
            </v-card-text>
          </v-card>
          </router-link>
            </a>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
    <v-layout row wrap>
      <v-container>
        <v-card class="edoabstandfooter">
        </v-card>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    components: {},
    name: 'Produkte',
    metaInfo: {
      // title will be injected into parent titleTemplate
      title: 'Produkte – die begeistern',
      meta: [
        {
          name: 'description',
          content: 'Entdecken Sie die Produktvielfalt der edologic.'
        }]
    },
    data () {
      return {
      }
    },
    methods: {
    },
    mounted () {
      console.log('Produkte')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Produkte.vue